/* Hygiene Hub Crew - change-request form helper (loads after hh-crew-extras.js).
   1) Fills the hidden Current plan / Plan reference fields on #hh-crew-change from
      window.HHCrew so the emailed request carries full context.
   2) Drops a low-friction "ask for a bigger tier" link into the Change-quantity and
      Add-a-box sheets, and wires it (and any [data-hhx-jump]) to jump to the form with
      the next tier pre-selected. No changes needed to the main hh-crew-extras.js. */
(function () {
  var CTX = window.HHCrew; if (!CTX) return;
  var STATE = CTX.STATE, cid = CTX.cid, prettyName = CTX.prettyName, CFG = CTX.CFG || {};
  function focus() { return STATE && STATE.f && STATE.f.focus; }
  function planSummary(c) {
    var parts = (c.lines || []).map(function (l) {
      return l.qty + ' x ' + (prettyName ? prettyName(l) : 'Grip-X') + (l.size ? ' ' + l.size : '');
    });
    return parts.join(' + ') + ' (' + c.boxes + ' box' + (c.boxes === 1 ? '' : 'es') + ' total)';
  }
  function fill() {
    var c = focus(); if (!c) return;
    var cur = document.getElementById('hhxCurPlan'); if (cur) cur.value = planSummary(c);
    var ref = document.getElementById('hhxCurRef');
    if (ref) ref.value = 'Contract ' + (cid ? cid() : '') + (CFG.customerId != null ? (' / customer ' + CFG.customerId) : '');
  }
  function setBox(sel, n) {
    n = parseInt(n, 10); if (!n) return;
    for (var i = 0; i < sel.options.length; i++) { if (parseInt(sel.options[i].text, 10) === n) { sel.selectedIndex = i; return; } }
    for (var j = 0; j < sel.options.length; j++) { if (/more than/i.test(sel.options[j].text)) { sel.selectedIndex = j; return; } }
  }
  /* smallest tier threshold above the customer's current box count = the next better rate */
  function nextTier() {
    var cur = (window.HH_CREW && window.HH_CREW.boxes) || 0;
    var th = [4, 6, 10, 20];
    for (var i = 0; i < th.length; i++) { if (th[i] > cur) return th[i]; }
    return '';
  }
  /* the untouched hh-crew-extras.js prints an old "...Reply to your order email..." line in
     [data-qhint]; strip that "Want..." clause so only our clean CTA shows. Re-strip on repaint. */
  function stripOldHint(sheet) {
    var h = sheet.querySelector('[data-qhint]'); if (!h) return;
    function clean() { var t = h.textContent || ''; var i = t.indexOf('Want'); if (i > 0) h.textContent = t.slice(0, i).trim(); }
    clean();
    if (!h.__hhobs) { h.__hhobs = new MutationObserver(clean); h.__hhobs.observe(h, { childList: true, characterData: true, subtree: true }); }
  }
  /* add a request link into an open sheet (once) */
  function injectCTA() {
    var sheet = document.querySelector('.hhx-sheet-wrap .hhx-sheet'); if (!sheet) return;
    stripOldHint(sheet);
    var body = sheet.querySelector('.hhx-sheet-b'); if (!body || body.querySelector('.hhx-req-cta')) return;
    var want = nextTier();
    var p = document.createElement('p');
    p.className = 'hhx-req-cta';
    p.innerHTML = 'Want ' + (want ? (want + '+ ') : 'more ') + 'boxes for a bigger volume discount? ' +
      '<a href="#hh-crew-change" data-hhx-jump="' + (want || '') + '">Ask us and we will set it up</a> &mdash; no need to cancel.';
    body.appendChild(p);
  }
  function wrap(name) {
    var a = CTX.act; if (!a || typeof a[name] !== 'function') return;
    var orig = a[name];
    a[name] = function () { var r = orig.apply(this, arguments); setTimeout(injectCTA, 0); return r; };
  }
  wrap('qty'); wrap('addextra');

  window.addEventListener('hh-crew:rendered', fill);
  document.addEventListener('click', function (e) {
    var t = e.target; var j = t && t.closest && t.closest('[data-hhx-jump]');
    if (!j) return;
    var form = document.getElementById('hh-crew-change'); if (!form) return;
    e.preventDefault();
    if (typeof CTX.closeSheet === 'function') { try { CTX.closeSheet(); } catch (err) {} }
    fill();
    var want = j.getAttribute('data-hhx-jump'); var b = document.getElementById('hhxBoxes');
    if (b) setBox(b, want || nextTier());
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var fe = document.getElementById('hhxBoxes'); if (fe) { try { fe.focus({ preventScroll: true }); } catch (err) {} }
  });
  fill();
})();
